'use strict';

require('../scss/base.scss');

require('../scss/pc.scss');

require('babel-polyfill');

require('es5-shim');

require('es5-shim/es5-sham');

var _fix = require('./util/fix');

var _fix2 = _interopRequireDefault(_fix);

var _top = require('./top');

var _top2 = _interopRequireDefault(_top);

var _booking = require('./booking');

var _booking2 = _interopRequireDefault(_booking);

var _exchange = require('./exchange');

var _exchange2 = _interopRequireDefault(_exchange);

var _header = require('./util/header');

var _header2 = _interopRequireDefault(_header);

var _fb = require('./fb');

var fb = _interopRequireWildcard(_fb);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _activity_config = require('./activity_config');

var _activity_config2 = _interopRequireDefault(_activity_config);

var _util = require('./util/util');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_activity_config2["default"].stat();
var events = {
    init: function init() {
        (0, _util.fixCid)();
        _fix2["default"].init(1920);
        _header2["default"].init();
        _top2["default"].pcInit();
        _booking2["default"].init();
        _exchange2["default"].pcInit();
        fb.init();
        _fix2["default"].init(1920);
    }
};

events.init();


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/pc.js
// module id = 347
// module chunks = 7